import type { Member } from './types/domain';
import { MemberRole } from './types/flowTypes';

export enum AssemblyCurrencyType {
  REGULAR = 'REGULAR',
  CUSTOM = 'CUSTOM',
}

export enum PrivateMessageAndImpactLevelValues {
  ManagerOnly = 'MANAGER_ONLY',
  AdminsOnly = 'ADMINS_ONLY',
  ManagerAndCustomAllowancesOnly = 'MANAGER_AND_CUSTOM_ALLOWANCES_ONLY',
  EVERYONE = 'EVERYONE',
}

export enum CurrencyLevel {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  HUGE = 'huge',
  ABOVE = 'above',
}

export enum GifRatingsProps {
  Y = 'y',
  G = 'g',
  PG = 'pg',
  PG13 = 'pg-13',
  R = 'r',
}

export type WorkspaceSettings = {
  userManagement: {
    approvalAccess: {
      enabled: boolean;
      value: string[];
    };
    inviteAccess: {
      enabled: boolean;
      value: ('ADMINS_AND_OWNER' | 'MANAGER' | 'EVERYONE')[];
    };
    canLoginUsingLink: {
      enabled: boolean;
    };
  };
  coreValues: {
    enabled: boolean;
    value: string[];
  };
  postImpactLevel: {
    enabled: boolean;
    value: {
      customType: PrivateMessageAndImpactLevelValues;
      levels: { percentage: number; name: CurrencyLevel }[];
    };
  };
  privateMessage: {
    enabled: boolean;
    value: PrivateMessageAndImpactLevelValues;
  };
  minMessageChar: {
    enabled: boolean;
    value: number;
  };
  gifAccessibility: {
    enabled: boolean;
    value: GifRatingsProps;
  };
  blockWordsMessage: {
    enabled: boolean;
    value: string[];
  };
  canDeletePosts: {
    enabled: boolean;
    value: string;
  };
  activeSpecialMention: string;
  badgeAttachability: { enabled: boolean };
  imageAttachability: { enabled: boolean };
};

export const isUserAdmin = ({ role }: { role: MemberRole[] }) =>
  role.some((currentRole) => {
    return currentRole === MemberRole.Admin || currentRole === MemberRole.Owner;
  });

export const isUserManager = (user: Member) => user.profile.isManager;

export const canInviteMembers = (
  member: Member | undefined,
  settings: WorkspaceSettings | undefined
) => {
  if (member) {
    if (isUserAdmin(member)) {
      return true;
    } else if (
      isUserManager(member) &&
      settings?.userManagement.inviteAccess.value.includes('MANAGER')
    ) {
      return true;
    } else if (
      settings?.userManagement.inviteAccess.value.includes('EVERYONE')
    ) {
      return true;
    }
    return false;
  }
  return false;
};
